module.exports = __webpack_public_path__ + "static/media/corn.78045166.png";